const STORAGE_KEY = "cz_braze_banner_heights_v1";

type HeightMap = Record<string, number>;

function readMap(): HeightMap {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as HeightMap;
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function writeMap(map: HeightMap): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // storage blocked
  }
}

/** Last measured height for a placement (same browser session). */
export function getCachedBannerHeight(placementId: string): number | null {
  const px = readMap()[placementId];
  return typeof px === "number" && px > 0 ? Math.round(px) : null;
}

export function setCachedBannerHeight(placementId: string, px: number): void {
  if (!placementId || px <= 0) return;
  const map = readMap();
  const rounded = Math.round(px);
  if (map[placementId] === rounded) return;
  map[placementId] = rounded;
  writeMap(map);
}

export function removeCachedBannerHeight(placementId: string): void {
  if (!placementId) return;
  const map = readMap();
  if (!(placementId in map)) return;
  delete map[placementId];
  writeMap(map);
}

export function clearAllCachedBannerHeights(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // storage blocked
  }
}
